import React from 'react';
import type { KBSettingsAppWithLayout as helpCenterSettingsKnowledgeBaseType } from '@atlassian/jira-spa-apps-help-center-settings-knowledge-settings/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyHelpCenterSettingsKnowledgeBase = lazyForPaint<
	typeof helpCenterSettingsKnowledgeBaseType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-help-center-settings-knowledge-base", jiraSpaEntry: "async-help-center-settings-knowledge-base" */ '@atlassian/jira-spa-apps-help-center-settings-knowledge-settings'
		),
	),
);

export const HelpCenterSettingsKnowledgeBase = (): React.JSX.Element => (
	<LazyPage
		Page={LazyHelpCenterSettingsKnowledgeBase}
		pageId="help-center-settings-knowledge-base"
		shouldShowSpinner
	/>
);
